<template>
	<ui-slideover v-on:close="$emit('close')" title="Filter by">
		<slot>
			<div class="flex flex-col h-full divide-y divide-gray-200 border-t">
				<ui-filter-renderer
					:filter="filter"
					:filter-options="filterOptions"
					v-on:select-my-products="selectMyProducts()"
					v-on:filter-clear="clearFilters()"
					v-on:filter-close="$emit('close')"
				/>
			</div>
		</slot>
	</ui-slideover>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		value: {
			type: Object,
		},
		showCity: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		let locationModes = options.locationModeOptions,
			acl = this.$inertia.page.props.acl;
		if (!acl.can_fob_cif) {
			locationModes = locationModes.filter(
				(o) => !o.traderAndIndustryOnly === true
			);
			console.log(locationModes);
		}
		let productGrades = new Array();
		Object.values(options.productGradeOptions)
			.flat()
			.forEach((o) => {
				if (o.group && o.default) {
					productGrades.push({ label: o.group, value: o.default });
				} else if (o.group) {
				} else {
					productGrades.push({ label: o.name, value: o.id });
				}
			});
		let productYears = options.harvestYearOptions.map(function (y) {
				return { label: y, value: y };
			}),
			dateType = [
				{
					label: this.__("At harvest"),
					value: "AT_HARVEST",
				},
				{
					label: this.__("Date range"),
					value: "MONTH",
				},
			],
			monthType = {
				month_from: null,
				month_to: null,
			},
			userFavoriteProductTypes =
				this.$inertia.page.props.user.favorite_product_types,
			sliderDistance = 0;

		locationModes = locationModes.map(function (o) {
			return { label: o.name, value: o.id };
		});
		let proteinValues = Object.keys(options.qualityStandardOptions)
			.filter((key) => key.includes("WHEAT_B"))
			.reduce((obj, key) => {
				return Object.assign(obj, {
					[key]: options.qualityStandardOptions[key],
				});
			}, {});
		proteinValues = Object.values(proteinValues)
			.flat()
			.map(function (y) {
				return { label: y.protein_min, value: y.protein_min };
			});
		let filterOptions = {
			productGrades: productGrades,
			productYears: productYears,
			dateType: dateType,
			monthType: monthType,
			sliderDistance: sliderDistance,
			proteinValues: proteinValues,
		};
		return {
			emptyFilter: {
				productGrades: [],
				productYears: [],
				proteinValues: [],
				bestOffers: 0,
				dateType: [],
				monthType: {
					month_from: null,
					month_to: null,
				},
				locationAddressCity: [],
			},
			filter: Object.assign({}, this.value),
			filterOptions: filterOptions,
			userFavoriteProductTypes: userFavoriteProductTypes,
		};
	},
	watch: {
		filter: {
			deep: true,
			handler: function (val) {
				console.log("THERE");

				this.$emit("input", val);
				console.log("EMIT", val);
			},
		},
	},
	methods: {
		clearFilters() {
			this.filter = JSON.parse(JSON.stringify(this.emptyFilter));
		},
		selectMyProducts() {
			this.filter.productGrades = [];
			this.userFavoriteProductTypes
				.map((t) => options.productGradeOptions[t])
				.flat()
				.forEach((option) => {
					if (
						option.id.includes("WHEAT_B") &&
						option.default &&
						!this.filter.productGrades.includes("WHEAT_B")
					) {
						this.filter.productGrades.push("WHEAT_B");
					} else if (
						!option.id.includes("WHEAT_B") &&
						!this.filter.productGrades.includes(option.id)
					) {
						this.filter.productGrades.push(option.id);
					}
				});
		},
	},
};
</script>
